import React from 'react';
import { connect } from 'react-redux';

import SummaryCard from './SummaryCard';
import { Section } from '../../ContentEdit';

//TODO: remove logic that filters bidTasks for each summary card.
const Summary = ({ classes, bid, bidTasks, preview }) => {
  let containsOptional = false;
  let containsTask = false;
  bidTasks.forEach((bidTask) => {
    containsTask = true;
    if (bidTask.optional) {
      containsOptional = true;
    }
  });

  return(
    <Section
      preview={preview}
      title="Summary"
      showContent={true}
      showAdd={false}>
      {containsTask &&
        <div>
          <SummaryCard
            title="Summary of Charges"
            bidTasks={bidTasks}
          />
          {containsOptional &&
            <SummaryCard
              title="Optional Charges"
              color="secondary"
              bidTasks={bidTasks.filter(bidTask => bidTask.optional === true)}
            />
          }
        </div>
      }
    </Section>
  );
};

Summary.defaultProps = {
  bid: {
    template: {}
  }
};

//TODO: use reselect for bidTasks so that they only reload when specific bidTasks change
const mapStateToProps = (state) => {
  const bidId = state.adminState.bid.id;
  return({
    bid: state.bidsState.find( bid => bid.id === bidId ),
    bidTasks: state.bidTasksState.filter( bidTask => bidTask.bidId === bidId)
  });
};


export default connect(mapStateToProps)(Summary);



// WEBPACK FOOTER //
// ./src/components/admin/Bids/Detail/Summary.jsx